import useFetchData from 'hooks/useFetchData';

function RedFlags() {
  const { data: redFlags } = useFetchData(
    `client-survey-measures/getRedFlags/1170`
  );
  return (
    <div>
      {redFlags?.length ? (
        <>
          <label>דגלים אדומים</label>
          {redFlags?.length &&
            redFlags.map((redFlag, index) => (
              <div key={index}>
                {`שם המדד: ${redFlag.name} הערך שנמדד: ${redFlag.redFlagValue} :הערת הבודק ${redFlag.redFlagText}`}
              </div>
            ))}
        </>
      ) : null}
    </div>
  );
}

export default RedFlags;
